import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Loader from "../../components/Loader";
import { IconButton, Icon } from "@material-ui/core";
import RemoveIcon from "@material-ui/icons/Remove";
import { pink } from "@material-ui/core/colors";

import {
  Grid,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Box,
  Table,
  Checkbox,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Drawer,
  Dialog,
} from "@material-ui/core";

import {
  FARMS,
  VEHICLE,
  PROJECT,
  USERS,
  EQUIPMENT,
  TEAMS,
  GET_SUPERVISOR_FOR_TEAM,
  DISTRICTS,
  SUB_DISTRICTS,
  VILLAGES,
} from "../../configs/urls";
import {
  ROLES as USER_ROLES,
  DATE_FORMATS,
  SUB_TEAM_TYPE,
} from "../../configs/constant";
import axios from "axios";
import { getApi, postApi } from "../../services/api";
import useForm from "../../formValidator/userForm";

import { Multiselect } from "multiselect-react-dropdown";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import AdminNavbarLinks from "../../components/Navbars/AdminNavbarLinks.js";
import { Prompt, useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import classNames from "classnames";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/icons/Menu";
import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import * as moment from "moment";
import SubTeam from "./subTeam";
import Toaster from "components/Toaster";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useAtom } from "jotai";
import { createdAllTeams } from "../../store/store";

const navBarStyles = makeStyles(styles);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "80%",
    margin: "auto",
  },
  tableMainContainer: {
    backgroundColor: "#eee",
    marginTop: 25,
    maxHeight: 250,
    overflowY: "scroll",
  },
  farmersTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#777",
    display: "inline",
    textTransform: "uppercase",
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5,
  },
  tableData: {
    borderLeft: "1px solid #ddd",
    borderBottom: "1px solid #ddd",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  formControl: {
    margin: theme.spacing(2, 0),
    minWidth: "100%",
  },
  pink: {
    color: theme.palette.getContrastText(pink[500]),
    backgroundColor: pink[500],
  },
  drawer: {
    width: 1024,
  },
  singleSelect: {
    width: "100%",
    marginTop: 19,
  },
}));

const multiselectStyle = {
  searchBox: {
    minHeight: "40px",
    marginTop: 19,
    border: "none",
    borderBottom: "1px solid #2b7b56",
  },
};

export default function TeamOperations(props) {
  const classes = useStyles();
  const [farms, setFarms] = useState([]);
  const [project, setProject] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [helpers, setHelpers] = useState([]);
  const [villagesList, setVillagesList] = useState([]);
  const [selectedVillages, setSelectedVillages] = useState([]);
  const [createdTeam, setCreatedTeam] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [confirmationPopupOpen, setConfirmationPopupOpen] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const [vehicles, setVehicles] = useState([]);
  const [districtsList, setDistrictsList] = useState([]);
  const [subDistrictList, setSubDistrictList] = useState([]);
  const [isRequesting, setIsRequestig] = useState(false);
  const [operationText, setOperationText] = useState("Create Team");
  const [action, setAction] = useState("create");
  const [tasks, setTasks] = useState([
    {
      driver_id: "",
      vehicle_id: "",
      equipment_id: "",
      helper_id: "",
    },
    {
      driver_id: "",
      vehicle_id: "",
      equipment_id: "",
      helper_id: "",
    },
    {
      driver_id: "",
      vehicle_id: "",
      equipment_id: "",
      helper_id: "",
    },
  ]);

  const [createdTeams, setCreatedTeams] = useAtom(createdAllTeams);

  const history = useHistory();
  const navBarClasses = navBarStyles();

  const { color } = props;

  const appBarClasses = classNames({
    [" " + navBarClasses[color]]: color,
  });

  const goBack = () => {
    history.goBack();
  };

  const validate = (values) => {
    let errors = {};

    if (!values.name) {
      errors.name = "Name is required";
    }

    if (!values.district_id) {
      errors.district_id = "District is required";
    }

    // if (!values.village_id) {
    //   errors.village_id = "Village is required";
    // }

    return errors;
  };

  const getSubDistrict = (e, value) => {
    let district_id = "";

    if (e != null) {
      handleChange(e);
      district_id = e.target.value;
    } else {
      district_id = value;
    }

    setSubDistrictList([]);

    setVillagesList([]);

    const items = [
      {
        id: "",
        villages: [],
      },
    ];

    // setFieldSupervisorsData(items);

    setIsRequestig(true);

    getApi(SUB_DISTRICTS, { district_id })
      .then(
        (res) => {
          setSubDistrictList(res.data || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };
  const selectSubDistrict = (subDistricts) => {
    var subDistrictIds = [];

    subDistricts.forEach((item) => {
      subDistrictIds.push(item.id);
    });

    setVillagesList([]);

    setIsRequestig(true);

    getApi(VILLAGES, {
      district_id: params.district_id,
      sub_district_ids: subDistrictIds,
    })
      .then(
        (res) => {
          setVillagesList(res.data || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  useEffect(() => {
    setIsRequestig(true);
    let getProject = getApi(PROJECT + "/" + props.match.params.project_id);
    let getFarms = null;
    const getVehicles = getApi(VEHICLE, { district_id: 1 });
    const getDrivers = getApi(USERS, { role: USER_ROLES.DRIVER });
    const getHelpers = getApi(USERS, { role: USER_ROLES.HELPER });
    const getEquipments = getApi(EQUIPMENT);
    const districts = getApi(DISTRICTS, { state_id: 1 });

    if (
      props.match &&
      props.match.params &&
      props.match.params.action &&
      props.match.params.action == "create"
    ) {
      getFarms = getApi(FARMS, {
        project_id: props.match.params.project_id,
        is_team_assigned: 0,
      });
    }

    axios
      .all([
        getFarms,
        getProject,
        getVehicles,
        getDrivers,
        getEquipments,
        districts,
        getHelpers,
      ])
      .then((res) => {
        if (res[0] && res[0].data) {
          res[0].data.map((farm) => {
            farm.checked = false;
          });

          setFarms(res[0].data);
        }

        if (res[1] && res[1].data) {
          setProject(res[1].data);
          var villagesListToSet = [];

          res[1].data.field_supervisors.map((supervisor) => {
            supervisor.villages.map((village) => {
              villagesListToSet.push(village.village);
            });
          });

          setVillagesList(villagesListToSet);
        }

        if (res[2] && res[2].data) {
          setVehicles(res[2].data);
        }

        if (res[3] && res[3].data) {
          setDrivers(res[3].data);
        }

        if (res[4] && res[4].data) {
          setEquipments(res[4].data);
        }

        if (res[5] && res[5].data) {
          setDistrictsList(res[5].data);
          params.district_id = res[1].data.district_id;
        }

        if (res[6] && res[6].data) {
          setHelpers(res[6].data);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setIsRequestig(false);
      });

    return function () {
      /**
       * Add cleanup code here
       */
      setIsRequestig(false);
    };
  }, []); //eslint-disable-line

  const saveTeam = () => {
    let villagesIds = [];

    if (selectedVillages.length > 0) {
      villagesIds = selectedVillages.map(function (obj) {
        return obj.id;
      });
    }
    let teamData = {
      name: params.name,
      sector_officer_id: props.match.params.sector_officer_id,
      project_id: props.match.params.project_id,
      village_id: villagesIds,
      district_id: params.district_id,
    };

    setIsRequestig(true);
    postApi(TEAMS, teamData)
      .then(
        (res) => {
          setCreatedTeam(res.data);
          Toaster.showSuccess("Team created successfully");
          setCreatedTeams({
            createTeam: true,
            createSubTeam: false,
          });
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
        setConfirmationPopupOpen(false);
      });
  };
  const openConfirmationPopupOpen = () => {
    setConfirmationPopupOpen(true);
  };
  const { params, errors, handleChange, handleSubmit } = useForm(
    openConfirmationPopupOpen,
    validate
  );
  useEffect(() => {
    if (params?.district_id) {
      getSubDistrict(null, params.district_id);
    }
  }, [params?.district_id]);
  const addOrRemoveTask = (action, idx) => {
    let items = [...tasks];

    if (action == "add") {
      items.push({
        driver_id: "",
        vehicle_id: "",
        equipment_id: "",
      });
    } else {
      items.splice(idx, 1);
    }

    setTasks(items);
  };

  const handleTaskFieldChange = (e, idx, key) => {
    let items = [...tasks];

    let item = { ...items[idx] };

    item[key] = e.target.value;

    items[idx] = item;

    setTasks(items);
  };

  const handleFarmCheckBox = (e, idx) => {
    let items = [...farms];
    let item = { ...farms[idx] };
    item["checked"] = e.target.checked;

    items[idx] = item;
    setFarms(items);
  };

  const renderFarmsTable = () => {
    return (
      <TableContainer component={Paper} className={classes.tableMainContainer}>
        <Table className={classes.table} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableData}>Select</TableCell>
              <TableCell className={classes.tableData}>Name</TableCell>
              <TableCell className={classes.tableData}>crop details</TableCell>
              <TableCell className={classes.tableData}>
                crop start date
              </TableCell>
              <TableCell className={classes.tableData}>
                crop harvest date
              </TableCell>
              <TableCell className={classes.tableData}>Total area</TableCell>
              <TableCell className={classes.tableData}>Village</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {farms.map((farm, idx) => (
              <TableRow key={idx}>
                <TableCell
                  className={classes.tableData}
                  component="th"
                  scope="row"
                >
                  <Checkbox
                    onChange={(e) => handleFarmCheckBox(e, idx)}
                    color="primary"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                  />
                </TableCell>

                <TableCell className={classes.tableData}>{farm.name}</TableCell>
                <TableCell className={classes.tableData}>
                  {farm.crop_details || "--"}
                </TableCell>
                <TableCell className={classes.tableData}>
                  {moment(farm.crop_start_date).format(
                    DATE_FORMATS.DATE_ONLY_FORMAT
                  ) || "--"}
                </TableCell>
                <TableCell className={classes.tableData}>
                  {moment(farm.crop_harvest_date).format(
                    DATE_FORMATS.DATE_ONLY_FORMAT
                  ) || "--"}
                </TableCell>
                <TableCell className={classes.tableData}>
                  {farm.total_area || "--"}
                </TableCell>
                <TableCell className={classes.tableData}>
                  {farm.village && farm.village.name ? farm.village.name : "--"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const renderTask = (task, idx) => (
    <GridContainer key={idx}>
      <GridItem xs={12} sm={12} md={2}>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id={"team-type-label-" + idx}>Team type</InputLabel>
          <Select
            labelId={"team-type-label-" + idx}
            id={"team-type-id-" + idx}
            name="team_type"
            onChange={(event) => handleTaskFieldChange(event, idx, "team_type")}
            label="Driver"
          >
            {SUB_TEAM_TYPE.map((subTeam, idx) => (
              <MenuItem key={idx} value={subTeam.value}>
                {subTeam.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={12} md={2}>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id={"driver-task-label-" + idx}>Driver</InputLabel>
          <Select
            labelId={"driver-task-label-" + idx}
            id={"driver-task-id-" + idx}
            name="driver_id"
            onChange={(event) => handleTaskFieldChange(event, idx, "driver_id")}
            label="Driver"
          >
            {drivers.map((driver, idx) => (
              <MenuItem key={idx} value={driver.id}>
                {driver.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={12} md={2}>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id={"helper-task-label-" + idx}>Helper</InputLabel>
          <Select
            labelId={"helper-task-label-" + idx}
            id={"helper-task-id-" + idx}
            name="helper_id"
            onChange={(event) => handleTaskFieldChange(event, idx, "helper_id")}
            label="Helper"
          >
            {helpers.map((helper, idx) => (
              <MenuItem key={idx} value={helper.id}>
                {helper.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={12} md={2}>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id={"vehicle-task-label-" + idx}>Vehicle</InputLabel>
          <Select
            labelId={"vehicle-task-label-" + idx}
            id={"vehicle-task-id-" + idx}
            name="vehicle_id"
            onChange={(event) =>
              handleTaskFieldChange(event, idx, "vehicle_id")
            }
            label="Vehicle"
          >
            {vehicles.map((vehicle, idx) => (
              <MenuItem
                key={idx}
                value={vehicle.id}
              >{`${vehicle.make} - ${vehicle.unique_number}`}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={12} md={2}>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id={"equipment-task-label-" + idx}>Equipment</InputLabel>
          <Select
            labelId={"equipment-task-label-" + idx}
            id={"equipment-task-id-" + idx}
            name="equipment_id"
            onChange={(event) =>
              handleTaskFieldChange(event, idx, "equipment_id")
            }
            label="Equipment"
          >
            {equipments.map((equipment, idx) => (
              <MenuItem
                key={idx}
                value={equipment.id}
              >{`${equipment.product_name} - ${equipment.unique_number}(${equipment.type.name})`}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </GridItem>
      {/* <GridItem xs={12} sm={12} md={2}>
				<FormControl variant="outlined" className={classes.formControl}>
					<InputLabel id={"priority-task-label-"+idx}>Priority</InputLabel>
					<Select
						labelId={"priority-task-label-"+idx}
						id={"priority-task-id-"+idx}
						name="priority_order"
						onChange={(event) => handleTaskFieldChange(event, idx, 'priority_order')}
						label="Priority"
					>
						{priorities.map((priority, idx) => <MenuItem key={idx} value={priority.value}>{priority.name}</MenuItem>)}
					</Select>
				</FormControl>
			</GridItem> */}
      <GridItem xs={12} sm={12} md={2}>
        <Grid
          container
          direction="row"
          justify="flex-end"
          alignItems="center"
          style={{ marginTop: 15 }}
        >
          {tasks.length == idx + 1 && tasks.length != 10 && (
            <>
              {idx + 1 != 1 && (
                <IconButton
                  edge="end"
                  aria-label="delete"
                  className={classes.marginTop25}
                  style={{ marginRight: 20 }}
                  onClick={() => addOrRemoveTask("remove", idx)}
                >
                  <RemoveIcon />
                </IconButton>
              )}
              <IconButton
                edge="end"
                aria-label="delete"
                className={classes.marginTop25}
                onClick={() => addOrRemoveTask("add", idx)}
              >
                <Icon>add_circle</Icon>
              </IconButton>
            </>
          )}
          {(tasks.length != idx + 1 || tasks.length == 10) && (
            <IconButton
              edge="end"
              aria-label="delete"
              className={classes.marginTop25}
              onClick={() => addOrRemoveTask("remove", idx)}
            >
              <RemoveIcon />
            </IconButton>
          )}
        </Grid>
      </GridItem>
    </GridContainer>
  );
  const openConformationDialog = () => (
    <Dialog
      open={confirmationPopupOpen}
      onClose={() => setConfirmationPopupOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Confirm"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => saveTeam()} color="primary" type="submit">
          Confirm
        </Button>
        <Button
          onClick={() => setConfirmationPopupOpen(false)}
          color="danger"
          autoFocus
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
  return (
    <>
      <AppBar className={navBarClasses.appBar + appBarClasses}>
        <Toolbar className={navBarClasses.container}>
          <div className={navBarClasses.flex}>
            {/* Here we create navbar brand, based on route name */}
            <Button
              color="transparent"
              onClick={() => goBack()}
              className={navBarClasses.title}
              startIcon={<ArrowBackIosIcon />}
            >
              Add Team
            </Button>
          </div>
          <Hidden smDown implementation="css">
            <AdminNavbarLinks />
          </Hidden>
          <Hidden mdUp implementation="css">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={props.handleDrawerToggle}
            >
              <Menu />
            </IconButton>
          </Hidden>
        </Toolbar>
      </AppBar>
      <div className={classes.root}>
        <Loader isLoading={isRequesting} />

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <form noValidate onSubmit={handleSubmit}>
              <Card>
                <CardHeader color="primary">
                  <h4 className={classes.cardTitleWhite}>{operationText}</h4>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <TextField
                        className={`${createdTeam.id ? classes.disable : ""}`}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        disabled={createdTeam.id != null}
                        id="name"
                        label="Name"
                        name="name"
                        type="text"
                        value={params.name || ""}
                        onChange={handleChange}
                      />
                      {errors.name && (
                        <Box color="secondary.main">{errors.name}</Box>
                      )}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl
                        variant="outlined"
                        className={`${classes.formControl} ${classes.disable}`}
                      >
                        <InputLabel id="create-team-district">
                          District
                        </InputLabel>
                        <Select
                          labelId="create-team-district"
                          id="create-team-district"
                          name="district_id"
                          value={params.district_id || ""}
                          onChange={(e) => getSubDistrict(e)}
                          label="district"
                        >
                          {districtsList.map((district, idx) => (
                            <MenuItem key={idx} value={district.id}>
                              {district.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {errors.district_id && (
                        <Box color="secondary.main">{errors.district_id}</Box>
                      )}
                    </GridItem>

                    {/*									
									<GridItem xs={12} sm={12} md={4}>
										{ <Grid
											container
											direction="row"
											justify="space-between"
											alignItems="center"
										>
											<FormControl variant="outlined" className={classes.formControl}>
												<InputLabel id="demo-simple-select-outlined-label">Village</InputLabel>
												<Select
													labelId="demo-simple-select-outlined-label"
													id="demo-simple-select-outlined"
													name="village_id"
													onChange={handleChange}
													label="Role"
												>
													{villages.map((village, idx) => <MenuItem key={idx} value={village.id}>{village.name}</MenuItem>)}
												</Select>
											</FormControl>
										</Grid> }
										<Multiselect
								            options={farms}
								            selectedValues={params.farmers}
								            onSelect={(selectedList, selectedItem) =>
								              handleFarmChange(selectedList)
								            }
								            placeholder="Select Farms"
								            style={multiselectStyle}
								            onRemove={(selectedList, removedItem) =>
								              handleFarmChange(selectedList)
								            }
								            displayValue="name"
								          />
									</GridItem>*/}
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <Multiselect
                        disable={createdTeam.id || params.district_id == null}
                        placeholder="Select Sub District"
                        displayValue="name"
                        style={multiselectStyle}
                        options={subDistrictList}
                        onSelect={(selectedList) =>
                          selectSubDistrict(selectedList)
                        }
                        onRemove={(selectedList) =>
                          selectSubDistrict(selectedList)
                        }
                      />
                    </GridItem>
                    {/* <GridItem xs={12} sm={12} md={6}>
                      <FormControl
                        variant="outlined"
                        className={`${classes.formControl} ${createdTeam.id ? classes.disable : ""
                          }`}
                      >
                        <InputLabel id="create-team-super-visor">
                          Supervisor
                        </InputLabel>
                        <Select
                          labelId="create-team-super-visor"
                          id="create-team-super-visor"
                          name="supervisor_id"
                          value={params.supervisor_id || ""}
                          onChange={handleChange}
                          label="Supervisor"
                        >
                          {supervisors.map((supervisor, idx) => (
                            <MenuItem key={idx} value={supervisor.id}>
                              {supervisor.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {errors.supervisor_id && (
                        <Box color="secondary.main">{errors.supervisor_id}</Box>
                      )}
                    </GridItem> */}
                    <GridItem xs={12} sm={12} md={6}>
                      <Multiselect
                        disable={villagesList == 0}
                        options={villagesList}
                        // selectedValues={fieldSupervisorsData[idx].villages}
                        onSelect={(selectedList, selectedItem) =>
                          setSelectedVillages(selectedList)
                        }
                        placeholder="Select Villages"
                        style={multiselectStyle}
                        onRemove={(selectedList, removedItem) =>
                          setSelectedVillages(selectedList)
                        }
                        displayValue="name"
                      />
                      {/* <FormControl
                        variant="outlined"
                        className={`${classes.formControl} ${
                          classes.singleSelect
                        } ${createdTeam.id ? classes.disable : ""}`}
                      >
                        <InputLabel id="create-team-village">
                          Village
                        </InputLabel>
                        <Select
                          labelId="create-team-village"
                          id="create-team-village"
                          name="village_id"
                          value={params.village_id || ""}
                          onChange={handleChange}
                          label="Village"
                        >
                          {villagesList.map((supervisor, idx) => (
                            <MenuItem key={idx} value={supervisor.id}>
                              {supervisor.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {errors.village_id && (
                        <Box color="secondary.main">{errors.village_id}</Box>
                      )} */}
                    </GridItem>
                  </GridContainer>
                  {/* {action != 'edit' ? tasks.map((task, idx) => renderTask(task, idx)) : null} */}

                  {/* <GridContainer>
										<GridItem xs={12} sm={12} md={12}>
											<div className={classes.marginTop25}>
												<h3 className={classes.farmersTitle}>Select farmers</h3>
											</div>
										</GridItem>
									</GridContainer>
									{renderFarmsTable()} */}
                </CardBody>
                <CardFooter>
                  <Grid
                    className={`${createdTeam.id ? "" : classes.disable}`}
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                  >
                    <Button
                      color="primary"
                      onClick={() => {
                        setIsDrawerOpen(true);
                      }}
                    >
                      Create Sub team
                    </Button>
                  </Grid>

                  <Grid
                    className={`${createdTeam.id ? classes.disable : ""}`}
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                  >
                    <Button color="primary" type="submit">
                      {operationText}
                    </Button>
                  </Grid>
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
        <Drawer
          anchor={"right"}
          open={isDrawerOpen}
          disableBackdropClick={true}
        >
          <SubTeam
            team={createdTeam}
            closeDrawer={(subTeamaction) => {
              setIsDrawerOpen(false);
              if (subTeamaction == "sub_team_added") {
                props.history.push("/admin/teams");
              }
            }}
          />
        </Drawer>
        {openConformationDialog()}
      </div>

      <Prompt
        when={createdTeams?.createTeam === true}
        message="Are you sure you want to leave?"
      />
      {/* <Prompt
        when={
          createdTeams?.createSubTeam === false &&
          createdTeams?.createTeam === true
        }
        message="Are you sure you want to create the sub-team"
      /> */}
    </>
  );
}
